import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    if (this.element) {
      setTimeout(() => {
        this.element.classList.add(
          "justify-center",
          "translate-y-1",
          "transition-all",
          "duration-[230ms]",
          "ease-[cubic-bezier(0.21,1.02,0.73,1)]",
        );
      }, 100);
      setTimeout(() => {
        if (this.element) {
          this.element.remove();
        }
      }, 5000);
    }
  }

  remove() {
    this.element.remove();
  }
}
